import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../Utilities/BreadCrumbs/Breadcrumbs";
import "./ShoppingBag.scss";
import {
  dagabengalurulogoPNG,
  FACEBOOK_LINK,
  INSTAGRAM_LINK,
  LINKEDIN_LINK,
  facebook_icon_png,
  instagram_icon_png,
  linkedin_icon_png,
  ARROW_FORWARD_BLACK_IC,
  BOX_IMG,
  CLOSE_IC_18,
  dagacomingsoon,
  DELETE_IC,
  OFFER_TAG_IC,
} from "../../../assets";
import ShoppingBagProductCard from "./ShoppingBagProductCard";
import Accordion from "./Accordion";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useGetUser from "../../../hooks/useGetUser";
import {
  addOrderDetails,
  removeOrderDetails,
} from "../../../redux/slices/myBagSlice";
import MODEL from "../../Master/MODEL";
import { toast } from "react-toastify";
import { useGetCouponListQuery } from "../../../redux/slices/homeSlice";
import BTN from "../../Master/BTN";
import LtoRScrollListing from "../../Master/LtoRScrollListing";
import ShoppingBagProductCardNew from "./ShoppingBagProductCardNew";
import { FilterSidePanel } from "../Category/FilterSidePanel";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useUploadPDFMutation } from "../../../redux/slices/bagPdfSlice";

const ShoppingBag = ({ setLensStep }) => {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Shopping Bag", link: "/shopping-bag" },
  ];

  const navigate = useNavigate();
  const recentProducts = useSelector(
    (state) => state.recentProducts.recentProducts
  );

  //  for filters
  const [showFilter, setShowFilter] = useState(false);
  const [sortBy, setSortBy] = useState({});
  const [totalDocs, setTotalDocs] = useState(0);
  const [attributeFilters, setAttributeFilters] = useState({});
  const [filterAttributesForShoppingBag, setFilterAttributesForShoppingBag] =
    useState();
  const showFilterHandler = () => {
    setShowFilter(!showFilter);
  };
  const [stockvalue, setStockValue] = useState("");
  console.debug("shoppingbag -> stockvalue", stockvalue);

  const user = useGetUser();
  const dispatch = useDispatch();
  const myBagitems = useSelector((state) => state.myBagData.items);
  // console.log(myBagitems);

  // Function to create a distinct object with the attributes of myBagitems
  // const getDistinctAttributes = (items) => {
  //   const attributesMap = {};

  //   items?.forEach((item) => {
  //     item?.attributes?.Jewellery?.forEach((attribute) => {
  //       const { attributeName, attributeValue } = attribute;
  //       if (!attributesMap[attributeName]) {
  //         attributesMap[attributeName] = new Set();
  //       }
  //       attributesMap[attributeName].add(attributeValue);
  //     });
  //   });

  //   const attributeFilters = {
  //     attribute_filters: Object.keys(attributesMap).map((attributeName) => ({
  //       attributeName,
  //       attributeValues: Array.from(attributesMap[attributeName]),
  //     })),
  //   };

  //   return attributeFilters;
  // };

  const getDistinctAttributes = (items) => {
    const attributesMap = {};

    items?.forEach((item) => {
      // Dynamically iterate over all keys under `attributes`
      Object.keys(item?.attributes || {}).forEach((key) => {
        item?.attributes?.[key]?.forEach((attribute) => {
          const { attributeName, attributeValue } = attribute;
          if (!attributesMap[attributeName]) {
            attributesMap[attributeName] = new Set();
          }
          attributesMap[attributeName].add(attributeValue);
        });
      });
    });

    const attributeFilters = {
      attribute_filters: Object.keys(attributesMap)?.map((attributeName) => ({
        attributeName,
        attributeValues: Array.from(attributesMap[attributeName]),
      })),
    };

    return attributeFilters;
  };

  useEffect(() => {
    const updatedFilters = getDistinctAttributes(myBagitems);
    setFilterAttributesForShoppingBag(updatedFilters);
    console.log(updatedFilters);
  }, [myBagitems]);

  // Sorting logic
  const sortedItems = [...myBagitems].sort((a, b) => {
    if (sortBy.value === "low") {
      return a.netWeight - b.netWeight; // Ascending Weight
    } else if (sortBy.value === "high") {
      return b.netWeight - a.netWeight; // Descending Weight
    }
    // Default: date-added-desc (keep as is for now)
    return 0;
  });

  console.log(attributeFilters);
  // Filtering logic
  console.log("Sorted Items:", sortedItems);

  const getBase64ImageFromUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const addFooterToPage = (doc, year) => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const footerHeight = 20; // Height of the footer area

    // Draw a rectangle with background color for the footer
    doc.setFillColor("#5d0d19"); // Footer background color
    doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");

    // Footer Text (Follow Us On)
    const textYPosition = pageHeight - footerHeight + 8; // Move text closer to the top of the footer
    doc.setFontSize(16);
    doc.setTextColor("#ede5de");
    doc.text("Follow Us On", pageWidth / 2, textYPosition, { align: "center" });

    // Social Media Icons
    const iconSize = 5; // Width and height of each icon
    const spacing = 5; // Space between icons
    const totalWidth = 3 * iconSize + 2 * spacing; // Total width of all icons and spacing
    const startX = (pageWidth - totalWidth) / 2; // Starting X position to center the icons
    const iconsYPosition = pageHeight - footerHeight + 12; // Move icons closer to the bottom edge of the footer

    // Add icons to the footer
    doc.addImage(
      instagram_icon_png,
      "PNG",
      startX,
      iconsYPosition,
      iconSize,
      iconSize
    );
    doc.link(startX, iconsYPosition, iconSize, iconSize, {
      url: INSTAGRAM_LINK,
    });

    doc.addImage(
      facebook_icon_png,
      "PNG",
      startX + iconSize + spacing,
      iconsYPosition,
      3.5,
      iconSize
    );
    doc.link(startX + iconSize + spacing, iconsYPosition, 3.5, iconSize, {
      url: FACEBOOK_LINK,
    });

    doc.addImage(
      linkedin_icon_png,
      "PNG",
      startX + 2 * (iconSize + spacing - 0.5),
      iconsYPosition,
      iconSize,
      iconSize
    );
    doc.link(startX + 2 * (iconSize + spacing), iconsYPosition, 4, iconSize, {
      url: LINKEDIN_LINK,
    });
  };
  const [isGenerating, setIsGenerating] = useState(false);
  const [uploadPDF] = useUploadPDFMutation();
  // ----------------->>> generateing pdf and save into local
  // const generateCartPDF = async (sortedItems) => {
  //   setIsGenerating(true);
  //   const doc = new jsPDF({
  //     orientation: "portrait",
  //     unit: "mm",
  //     format: "a4",
  //     compress: true,
  //   });
  //   const year = new Date().getFullYear();

  //   // Add the logo to every page with background color
  //   const addLogoToPage = () => {
  //     const pageWidth = doc.internal.pageSize.getWidth();
  //     const headerHeight = 32;
  //     const imageWidth = 20;
  //     const xPosition = (pageWidth - imageWidth) / 2;

  //     // Set background color for the header
  //     doc.setFillColor("#ede5de");
  //     doc.rect(0, 0, pageWidth, headerHeight, "F"); // Draw filled rectangle for header

  //     // Add the logo inside the header
  //     doc.addImage(dagabengalurulogoPNG, "PNG", xPosition, 3, imageWidth, 25); // Adjust y-position to fit inside header
  //   };

  //   // Add logo and footer to the first page
  //   addLogoToPage();
  //   addFooterToPage(doc, year);

  //   // Position to start adding items
  //   let startY = 43;

  //   const sortedItemsArray = Array.isArray(sortedItems)
  //     ? sortedItems
  //     : Object.values(sortedItems);

  //   for (const item of sortedItemsArray) {
  //     const modifiedImageUrl = item.image[0].replace(
  //       /\/upload\/(.*?)/,
  //       "/upload/w_300,h_300,q_50,f_auto/"
  //     );

  //     // Convert image URL to Base64 (item's image)
  //     const imageBase64 = await getBase64ImageFromUrl(modifiedImageUrl);
  //     doc.setTextColor(0, 0, 0);
  //     // Add the item image to the PDF
  //     doc.addImage(imageBase64, "JPEG", 14, startY, 30, 35); // (Base64, type, x, y, width, height)

  //     // Add the item details next to the image
  //     doc.setFontSize(12);
  //     doc.text(`Product Name: ${item?.name || "N/A"}`, 55, startY + 5);
  //     doc.text(`Net Weight: ${item?.netWeight || "N/A"}`, 55, startY + 15);
  //     doc.text(
  //       `Price: ${item?.prices?.price ? `$${item.prices.price}` : "N/A"}`,
  //       55,
  //       startY + 25
  //     );
  //     doc.text(`Quantity: ${item?.quantity || "N/A"}`, 55, startY + 35);

  //     // Move to the next position
  //     startY += 47;

  //     // Add a new page if content exceeds the current page
  //     if (startY > 250) {
  //       doc.addPage();
  //       addLogoToPage(); // add header with logo and background color on new page
  //       addFooterToPage(doc, year);
  //       startY = 43; // reset Y position for the new page
  //     }
  //   }

  //   doc.save("products-in-bag.pdf");
  //   setIsGenerating(false);
  // };

  const generateCartPDF = async (sortedItems) => {
    setIsGenerating(true);
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const year = new Date().getFullYear();

    // Add the logo to every page with background color
    const addLogoToPage = () => {
      const pageWidth = doc.internal.pageSize.getWidth();
      const headerHeight = 32;
      const imageWidth = 20;
      const xPosition = (pageWidth - imageWidth) / 2;

      // Set background color for the header
      doc.setFillColor("#ede5de");
      doc.rect(0, 0, pageWidth, headerHeight, "F");

      // Add the logo inside the header
      doc.addImage(dagabengalurulogoPNG, "PNG", xPosition, 3, imageWidth, 25);
    };

    addLogoToPage();
    addFooterToPage(doc, year);

    let startY = 43;
    const sortedItemsArray = Array.isArray(sortedItems)
      ? sortedItems
      : Object.values(sortedItems);

    for (const item of sortedItemsArray) {
      const modifiedImageUrl =
        item?.image?.[0]
          ?.replace(/\/upload\/(.*?)/, "/upload/w_300,h_300,q_50,f_auto/")
          ?.replace(/^http:/, "https:") || dagabengalurulogoPNG;
      const imageBase64 = await getBase64ImageFromUrl(modifiedImageUrl);
      doc.setTextColor(0, 0, 0);
      // Add the item image to the PDF
      doc.addImage(imageBase64, "JPEG", 14, startY, 30, 35); // (Base64, type, x, y, width, height)

      doc.setFontSize(12);
      doc.text(`Product Name: ${item?.name || "N/A"}`, 55, startY + 5);
      doc.text(`Net Weight: ${item?.netWeight || "N/A"}`, 55, startY + 15);
      doc.text(
        `Price: ${item?.prices?.price ? `$${item.prices.price}` : "N/A"}`,
        55,
        startY + 25
      );
      doc.text(`Quantity: ${item?.quantity || "N/A"}`, 55, startY + 35);

      startY += 47;

      if (startY > 231) {
        doc.addPage();
        addLogoToPage();
        addFooterToPage(doc, year);
        startY = 43;
      }
    }

    const pdfBlob = doc.output("blob");
    console.log("PDF Blob:", pdfBlob);

    const formData = new FormData();
    formData.append("file", pdfBlob, "products-in-bag.pdf");
    console.log("FormData:", formData);

    console.log("Form Data before sending:", formData);

    try {
      const response = await uploadPDF(formData);
      console.log("response---------------", response);
      console.log(
        "File uploaded successfully. Download URL:",
        response?.data?.url
      );
      setIsGenerating(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsGenerating(false);
    }
  };

  // const filteredItems = sortedItems?.filter((item) => {
  //   return Object.keys(attributeFilters).every((filterKey) => {
  //     const filterValues = attributeFilters[filterKey]
  //       .split(",")
  //       .map((value) => value.trim());
  //     const result = item?.attributes?.Jewellery?.some(
  //       (attribute) =>
  //         attribute?.attributeName === filterKey &&
  //         filterValues.includes(attribute?.attributeValue)
  //     );
  //     console.log(`Filtering item: ${item?.id}, result: ${result}`);
  //     return result;
  //   });
  // });

  const filteredItems = sortedItems?.filter((item) => {
    // Apply attribute filters
    const attributesMatch = Object.keys(attributeFilters).every((filterKey) => {
      const filterValues = attributeFilters[filterKey]
        .split(",")
        .map((value) => value.trim());
      const result = Object.keys(item?.attributes || {}).some((key) =>
        item?.attributes[key]?.some(
          (attribute) =>
            attribute?.attributeName === filterKey &&
            filterValues.includes(attribute?.attributeValue)
        )
      );
      console.log(`Filtering item: ${item?.id}, result: ${result}`);
      return result;
    });

    // for filtering by stock
    const stockMatch = (() => {
      if (stockvalue === "inStock") {
        return item?.stock > 0;
      }
      if (stockvalue === "makeToOrder") {
        return item?.stock < 1;
      }
      return true;
    })();

    return attributesMatch && stockMatch;
  });

  console.log("Filtered Items:", filteredItems);
  console.log("Filter Attributes:", attributeFilters);

  //updating filtered items count
  useEffect(() => {
    setTotalDocs(filteredItems?.length);
  }, [filteredItems]);

  const orderDetails = useSelector((state) => state?.myBagData?.orderDetails);

  const [traySectionToggle, setTraySectionToggle] = useState(true);
  const [couponsToggle, setCouponsToggle] = useState(false);
  const accordionData = [
    {
      title: "Contact Us",
      content: "Daga Gems Contact Us",
    },
    {
      title: "Shopping and Returns",
      content: "Daga Gems Shopping and Returns",
    },
    {
      title: "Payment and secure Transactions",
      content: "Daga Gems Payment and secure Transactions",
    },
    {
      title: "After care",
      content: "Daga Gems After care",
    },
  ];

  const subTotal = () => {
    return myBagitems?.reduce((total, item) => {
      // Calculate the product price based on quantity
      let productWeight = Number(item?.netWeight) * Number(item?.quantity);
      const finalWeight = Number(total) + productWeight;
      const final = finalWeight.toFixed(2);
      // console.log(final);
      return final;
    }, 0);
  };

  // const total = myBagitems.reduce(
  //   (acc, item) =>
  //     acc + item.prices.price * item.quantity + (item?.lensDetails?.price || 0),
  //   0
  // );

  const {
    data: couponData,
    isSuccess: couponDataIsSuccess,
    isLoading: couponDataIsLoading,
    isError: couponDataIsError,
    error: couponDataError,
  } = useGetCouponListQuery(
    { user: user, couponType: "online" },
    { skip: !user }
  );

  const formateDate = (date) => {
    const estimatedDeliveryDate = new Date(date);
    estimatedDeliveryDate.setDate(estimatedDeliveryDate.getDate());
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedEstimatedDeliveryDate =
      estimatedDeliveryDate.toLocaleDateString("en-GB", options);
    return formattedEstimatedDeliveryDate;
  };

  const handleCopyClick = (textToCopy) => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.success("Coupon code copied to clipboard!");
      })
      .catch((err) => {
        toast.success("Failed to copy text: ");
      });
  };

  const checkCouponCodeIsValid = (coupon) => {
    const endTime = new Date(coupon?.endTime);
    const currentTime = new Date();

    if (currentTime > endTime) {
      toast.error("Your coupon was expired!");
      return false;
    }
    if (subTotal() < coupon?.minimumAmount) {
      toast.error(
        `This coupon is valid for minimum order ${coupon?.minimumAmount}!`
      );
      return false;
    }
    if (coupon?.couponQuantity === 0) {
      toast.error(`This coupon's quantity is ${coupon?.couponQuantity}!`);
      return false;
    }
    return true;
  };

  const checkEndDateOfCoupon = (coupon) => {
    const endTime = new Date(coupon?.endTime);
    const currentTime = new Date();
    if (currentTime > endTime || coupon?.couponQuantity === 0) {
      return true;
    } else {
      return false;
    }
  };

  const calculateCouponOffer = (coupon) => {
    if (coupon) {
      if (coupon?.discountType?.type === "fixed") {
        return subTotal() - coupon?.discountType?.value;
      } else {
        return Math.ceil(
          parseFloat(
            subTotal() - (subTotal() * coupon?.discountType?.value) / 100
          ).toFixed(2)
        );
      }
    } else {
      return subTotal();
    }
  };

  const couponApplyHandle = (item) => {
    if (checkCouponCodeIsValid(item)) {
      dispatch(
        addOrderDetails({
          ...orderDetails,
          couponCode: item,
        })
      );
      setCouponsToggle(false);
      toast.success(`${item?.couponCode} applied`);
    }
  };

  const isNotGo = () => {
    return myBagitems?.some((item) =>
      item?.quantity < item?.lensDetails?.length ? true : false
    );
  };

  const goCheckOutHandle = () => {
    if (isNotGo()) {
      toast.error("Your lens quantities are more then Frames quantities!", {
        autoClose: 4000,
      });
      return;
    }
    navigate(user?.customer ? "/shopping-tray" : "/signup", {
      state: { isNewUser: user?.customer ? false : true },
    });
  };
  const [active, setActive] = useState("In Stock");
  return (
    <div className="shopping_bag_main lato-regular">
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <FilterSidePanel
        showFilter={showFilter}
        showFilterHandler={showFilterHandler}
        setSortBy={setSortBy}
        totalDocs={totalDocs}
        setAttributeFilters={setAttributeFilters}
        filterAttributesForShoppingBag={filterAttributesForShoppingBag}
        setStockValue={setStockValue}
      />
      <div className="header_div">
        {/* <div
          className={` ${
            traySectionToggle && "active_header"
          } shopping_tray_div text-primary text-3xl border-b-2 border-primary`}
          onClick={() => setTraySectionToggle(true)}
        >
          Shopping Tray
        </div> */}
        {/* <div
          className={` ${!traySectionToggle && "active_header"} trial_tray_div`}
          onClick={() => setTraySectionToggle(false)}
        >
          Trial Tray
        </div> */}
      </div>
      {/* <div className="flex justify-center items-center h-auto pt-0 mb-4">
        <div className="flex bg-gradient-to-r from-primary via-primary to-[#BCA24E] xs:p-1 sm:p-2 lg:p-2 rounded-full xs:w-52 xs:text-sm md:text-base sm:w-80 lg:w-80">
          <button
            className={`flex-1 xs:py-1 sm:py-2 rounded-full font-medium text-center transition-all ${
              active === "Make Order"
                ? "bg-white text-primary"
                : "bg-transparent text-white"
            }`}
            onClick={() => setActive("Make Order")}
          >
            Make Order
          </button>
          <button
            className={`flex-1 xs:py-1 sm:py-2 rounded-full font-medium text-center transition-all ${
              active === "In Stock"
                ? "bg-white text-primary"
                : "bg-transparent text-white"
            }`}
            onClick={() => setActive("In Stock")}
          >
            In Stock
          </button>
        </div>
      </div> */}
      {traySectionToggle ? (
        <div className="shopping_tray_main">
          <div className="shopping_tray_one flex-col emd:flex-row gap-4">
            <div className="flex flex-col w-full">
              <div className="flex justify-between flex-grow w-full emd:pb-4">
                <div className="text-base lm:text-lg text-primary">
                  Bag Items ({myBagitems?.length})
                </div>
                <div
                  className="text-primary text-base lm:text-lg cursor-pointer"
                  onClick={showFilterHandler}
                >
                  SORT AND FILTER
                </div>
              </div>
              <div
                className={` ${
                  myBagitems?.length === 0
                    ? "grid-cols-1"
                    : "grid-cols-1 fix_lg:grid-cols-2 gap-4"
                } left_top_div w-full`}
              >
                {/* <div className={` left_top_div`}> */}
                {myBagitems?.length === 0 ? (
                  <div className="w-full flex-col my-52 flex items-center justify-center">
                    <span className="text-text_dark_3 text-2xl">
                      Your Bag is empty!
                    </span>
                    <BTN
                      className={
                        "mt-16 py-1 px-4 lg:w-auto md:w-auto small:w-fit text-primary"
                      }
                      title="Start shopping"
                      bordered
                      to={"/search"}
                    />
                  </div>
                ) : (
                  filteredItems?.map((item, index) => {
                    return (
                      <ShoppingBagProductCardNew
                        key={index}
                        data={item}
                        setLensStep={setLensStep}
                      />
                    );
                  })
                )}
                {/* myBagitems.map((item, index) => {
                  return (
                    <ShoppingBagProductCard
                      key={index}
                      product={item}
                      setLensStep={setLensStep}
                    />
                  );
                }) */}

                {/* daga care  */}
                {/* <div className="radio_selection_section">
                <div className="selection_title_one">
                  <label className="radio_heading_text" htmlFor="option1">
                    Buy Daga Care (₹600)
                  </label>
                  <input
                    type="radio"
                    className="radio_btn"
                    id="option1"
                    checked={isGift === "option1"}
                    onChange={() => setIsGift("option1")}
                  />
                </div>
                <div className="radio_desc">
                  Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
                  Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
                  Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
                  Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
                </div>
              </div> */}
                {/* gift wrap */}
                {/* {myBagitems?.length !== 0 && (
                <div className="radio_selection_section">
                  <div className="selection_title_one">
                    <label
                      className="radio_heading_text select-none text-primary"
                      htmlFor="gift"
                    >
                      Is this a gift ?
                    </label>
                    <input
                      type="checkbox"
                      className="radio_btn accent-primary"
                      id="gift"
                      checked={orderDetails?.isGift}
                      // onChange={(e) => setIsGift(e.target.checked)}
                      onChange={(e) =>
                        dispatch(
                          addOrderDetails({
                            ...orderDetails,
                            isGift: e.target.checked,
                          })
                        )
                      }
                    />
                  </div>
                  {orderDetails?.isGift && (
                    <div className="radio_desc">
                      <div className="gift_message">
                        <span>Gift Message (Optional)</span>
                        <textarea
                          rows={3}
                          className="gift_message_textarea"
                          placeholder="Message"
                          value={orderDetails?.giftMessage}
                          onChange={(e) =>
                            dispatch(
                              addOrderDetails({
                                ...orderDetails,
                                giftMessage: e.target.value,
                              })
                            )
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              )} */}
              </div>
            </div>

            {myBagitems?.length !== 0 && (
              <div className="right_bottom_div bg-bg_1 min-w-[300px]">
                <div className="checkout_card_main bg-bg_1">
                  <span className="checkout_card_heading lato-medium">
                    Order Summary
                  </span>
                  <div className="title_one_div lato-regular">
                    <span className="bill_title">Sub total</span>
                    <span className="bill_title lato-semibold">
                      {subTotal()}&nbsp;g
                    </span>
                  </div>
                  {/* <div className="title_two_div">
                    <span className="bill_title">Delivery</span>
                    <span className="bill_title">FREE</span>
                  </div> */}
                  {/* {orderDetails?.isGift && (
                    <div className="title_two_div">
                      <span className="bill_title">Gift Wrap</span>
                      <span className="bill_title">FREE</span>
                    </div>
                  )} */}
                  {/* <div className="title_two_div">
                    <span className="bill_title">Offer discount</span>
                    <span className="bill_title">
                      - ₹
                      {Math.ceil(
                        parseFloat(
                          subTotal() -
                            calculateCouponOffer(orderDetails?.couponCode)
                        )?.toFixed(2)
                      )}
                    </span>
                  </div>
                  {orderDetails?.couponCode && (
                    <span className="offers_label mb-2">Coupon Code:</span>
                  )} */}
                  {orderDetails?.couponCode && (
                    <div className="offers_div">
                      <div className="offer_chip_div">
                        <div className="offer_chip bg-primary">
                          <img src={OFFER_TAG_IC} alt="" />
                          <span className=" text-text_light_2">
                            {orderDetails?.couponCode?.couponCode}
                          </span>
                          <img
                            onClick={() =>
                              dispatch(
                                removeOrderDetails({
                                  items: myBagitems,
                                  orderDetails: {
                                    isGift: orderDetails?.isGift,
                                    giftMessage: orderDetails?.giftMessage,
                                    couponCode: null,
                                  },
                                })
                              )
                            }
                            src={CLOSE_IC_18}
                            alt=""
                            className="cursor-pointer"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {/* <span
                    className="view_offers text-primary"
                    onClick={() => setCouponsToggle(true)}
                  >
                    View offers
                  </span> */}
                  <hr className="hr_checkout" />
                  <div className="total_div">
                    <span className="total_title lato-medium">
                      Total Weight
                    </span>
                    <span className="total_title lato-bold">
                      {subTotal()}&nbsp;g
                    </span>
                  </div>
                  <button
                    disabled={myBagitems?.length === 0}
                    className="checkout_btn lato-semibold bg-primary text-text_light_2"
                    onClick={() => goCheckOutHandle()}
                  >
                    Checkout
                  </button>
                  <div>
                    <button
                      className="uppercase lato-semibold text-base  w-full py-2 mt-4 cursor-pointer border-2 border-primary text-primary"
                      onClick={() => generateCartPDF(sortedItems)}
                      disabled={isGenerating}
                    >
                      {isGenerating ? "Generating..." : "Download Bag Items"}
                    </button>
                  </div>
                </div>
                {/* <div className="experience_div">
                  <span className="experience_heder lato-regular text-primary">
                    The Daga Gems Experience
                  </span>
                  <div>
                    {accordionData?.map((item, index) => {
                      return (
                        <Accordion
                          key={index}
                          title={item?.title}
                          content={item?.content}
                        />
                      );
                    })}
                  </div>
                </div> */}
              </div>
            )}
          </div>
          {/* <div className="box_div bg-bg_1 "> */}
          <div className="w-full md:w-[60%] bg-bg_1 grid md:grid-cols-2 mt-12 items-center p-8 gap-8 text-center">
            <span className="text-2xl lato-medium text-primary w-full text-center sm:px-12 md:px-0">
              Every purchase of jewel comes with an iconic Daga Gems box
            </span>
            <img
              src={dagacomingsoon}
              alt=""
              className="aspect-square object-contain lm:h-[300px] md:h-auto w-full"
            />
          </div>
        </div>
      ) : (
        <div>Trial Tray</div>
      )}
      {recentProducts?.length > 0 && (
        <LtoRScrollListing
          title={"Recently Viewed"}
          classForTitle="color-2"
          data={recentProducts}
        />
      )}
      {/* ============================== SHIPPING ADDRESS ====================== */}
      <MODEL
        showModel={couponsToggle}
        setShowModel={setCouponsToggle}
        title="Select coupon"
      >
        <div className="w-full min-h-[60dh] max-h-[60dvh] overflow-auto lg:px-10 emd:px-5 small:px-4 pb-10 grid lg:grid-cols-3 emd:grid-cols-2 small:grid-cols-1  auto-rows-auto gap-4 hide_scrollbar items-center">
          {couponData?.coupons?.map((item, index) => {
            return item?.status === "show" ? (
              <div
                key={index}
                className={`${
                  orderDetails?.couponCode?.couponCode === item?.couponCode
                    ? "border-primary border-2"
                    : "border-[#8B94B2] border"
                } p-4 select-none lg:h-64 emd:h-56 small:h-48 min-w-full max-w-full flex flex-col justify-between ${
                  checkEndDateOfCoupon(item) ? "opacity-50" : ""
                } `}
              >
                <div className="w-full flex items-center">
                  {/* <span className="text-2xl font-bold">40% OFF</span>
                  <span className="text-lg">For whole order</span> */}
                  <span className="text-2xl font-bold text-primary">
                    {item?.couponCode}
                  </span>
                  {/* <div
                    onClick={() => handleCopyClick(item?.couponCode)}
                    className="flex items-center ms-3 cursor-pointer"
                  >
                    <div className="material-symbols-outlined text-xl text-primary">
                      content_copy
                    </div>
                    <span className="ms-2 text-primary">Copy</span>
                  </div> */}
                </div>
                <div className="flex items-center">
                  <ul>
                    <li className="text-light_secondary text-sm">
                      {item?.title?.en}
                    </li>
                    <li className="text-light_secondary text-sm">
                      Minimum Amount : {item?.minimumAmount}
                    </li>
                    <li className="text-light_secondary text-sm">
                      Valid on {formateDate(item?.endTime)} order only
                    </li>
                  </ul>
                </div>
                <div className="w-full flex flex-col justify-between">
                  <div className=" flex items-center">
                    <button
                      disabled={checkEndDateOfCoupon(item)}
                      onClick={() => couponApplyHandle(item)}
                      className={`flex items-center ${
                        checkEndDateOfCoupon(item)
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <div className="material-symbols-outlined">
                        <img
                          src={ARROW_FORWARD_BLACK_IC}
                          alt=""
                          className="w-5"
                        />
                      </div>
                      <span className="ms-2">Apply</span>
                    </button>
                  </div>
                </div>
              </div>
            ) : null;
          })}
        </div>
      </MODEL>
    </div>
  );
};

export default ShoppingBag;
